import { Banner, BannerTypes } from "@sunrun/experience-ui-components";
import { formatNumber } from "utils/formatHelpers";

const OfferReviewSquareFootageEstimateBanner = ({
  homeSizeEstimate,
  onClickPrimaryAction,
}: {
  homeSizeEstimate: number;
  onClickPrimaryAction: () => void;
}) => {
  return (
    <Banner
      bannerType={BannerTypes.WarningLight}
      show={true}
      showClose={false}
      showIcon={true}
      data-testid="offer-review-square-footage-estimate-banner"
      primaryAction={{
        title: "Share usage",
        action: onClickPrimaryAction,
        testId: "offer-review-share-usage-button",
      }}
    >
      This offer is based on an estimated square footage of{" "}
      {formatNumber(homeSizeEstimate)}. Please share your usage for greater
      accuracy.
    </Banner>
  );
};

export { OfferReviewSquareFootageEstimateBanner };
